
export const formatPoaQuestionLabel = (question, type, separator = ' -') => {
  if (typeof question !== 'string' || !question.trim()) return ''
  if (type === 'Header') return question
  return `${question}${type === 'subHeader' ? ' :' : separator}`
}
